module.exports = __webpack_public_path__ + "img/img_works13.b88387e2.jpg";